//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from '../transitions/Expand.vue'
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "FilteringFacet",
  props: ["options", "depth"],
  components: {
    TransitionExpand
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    ...mapGetters(["model", "lookup", "weightedSort"]),
    value: {
      get() {
        return this.model[this.depth];
      },
      set(v) {
        this.updateModel({ value: v, depth: this.depth });
      },
    },
    selected() {
      return this.options.find((opt) => opt.categoryId === this.value);
    },
  },
  methods: {
    ...mapMutations(["updateModel", "setWeightedSort"]),
    close(e) {
      if (e.target.closest('.filtering__facet') === this.$el) return;
      this.open = false;
    },
    toggleWeightedSort () {
      const selectedOption = this.options.find((opt) => opt.categoryId === this.value)
      // set weighted sort based on json response
      if(selectedOption.categoryWeight) {
        this.setWeightedSort(selectedOption.categoryWeight)
      } else {
        this.setWeightedSort(false)
      }
    }
  },
  created() {
    window.addEventListener('click', this.close)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close)
  }
};
